import { motion } from "framer-motion";

const draw = {
  hidden: { pathLength: 0, opacity: 0 },
  show: (d = 0) => ({
    pathLength: 1,
    opacity: 1,
    transition: {
      pathLength: { duration: 1.1, ease: "easeInOut", delay: d },
      opacity: { duration: 0.2, delay: d },
    },
  }),
};

// Hand-drawn ellipse scribble that wraps text (positioned absolutely by parent).
export const CircleScribble = ({ className = "", color = "#DA983C", delay = 0, pathClass = "" }) => (
  <motion.svg
    className={className}
    viewBox="0 0 300 120"
    fill="none"
    preserveAspectRatio="none"
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-40px" }}
    aria-hidden="true"
  >
    <motion.path
      className={`annotation-scribble ${pathClass}`.trim()}
      d="M148 8C92 4 24 18 12 52c-12 34 62 60 140 60 70 0 148-20 146-58C296 20 214 12 150 10"
      stroke={color}
      strokeWidth="3"
      strokeLinecap="round"
      variants={draw}
      custom={delay}
    />
  </motion.svg>
);

// Hand-drawn underline stroke.
export const Underline = ({ className = "", color = "#90533B", delay = 0 }) => (
  <motion.svg
    className={className}
    viewBox="0 0 300 20"
    fill="none"
    preserveAspectRatio="none"
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-40px" }}
    aria-hidden="true"
  >
    <motion.path
      d="M4 12c60-6 130-9 210-6 26 1 56 3 82 6"
      stroke={color}
      strokeWidth="3"
      strokeLinecap="round"
      variants={draw}
      custom={delay}
    />
  </motion.svg>
);

// Hand-drawn arrow (curved) pointing down-right, used to connect notes.
export const Arrow = ({ className = "", color = "#B87B5C", delay = 0 }) => (
  <motion.svg
    className={className}
    viewBox="0 0 120 120"
    fill="none"
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-40px" }}
    aria-hidden="true"
  >
    <motion.path
      d="M12 14c34 6 66 30 78 74"
      stroke={color}
      strokeWidth="2.5"
      strokeLinecap="round"
      variants={draw}
      custom={delay}
    />
    <motion.path
      d="M64 82c10 8 20 12 28 8M92 90c2-10 0-20-6-28"
      stroke={color}
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      variants={draw}
      custom={delay + 0.5}
    />
  </motion.svg>
);

// Small rehearsal "checkmark" tick used in lists.
export const Tick = ({ className = "", color = "#90533B" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M4 13l5 6L21 4"
      stroke={color}
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// A small margin star / asterisk annotation.
export const Star = ({ className = "", color = "#B87B5C" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 2v20M4 6l16 12M20 6L4 18" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);
